// "Needs help" on the Login problems page: the athletes behind the Admin home's queue.
// Names and ids only; the endpoint never returns email addresses or credentials.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

// Server timestamps are UTC without a tz suffix; append Z so they render in the viewer's zone.
const when = (iso) => {
  if (!iso) return null;
  const d = new Date(/([zZ])|([+-]\d{2}:?\d{2})$/.test(iso) ? iso : `${iso}Z`);
  return Number.isNaN(d.getTime()) ? null : d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
};

export default function LoginIssuesPanel() {
  const { API_URL } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/admin/reports/login-issues`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => setData(r.data))
      .catch(() => setError('Could not load the athletes who need help. Refresh to try again.'));
  }, [API_URL]);

  if (error) return <div role="alert" className="adm-error">{error}</div>;
  if (!data) return <div className="adm__card"><div className="adm-loading">Checking who needs help…</div></div>;
  const nobody = !data.athletes.length && !(data.bad_email_athletes || []).length;
  return (
    <section className="adm__card adm-help" data-testid="login_issues_panel" aria-label="Needs help">
      <div className="adm-card__head">
        <h2 className="adm-card__title">Needs help</h2>
        <span className="adm-pill adm-pill--amber">{`${data.count} struggling · ${data.bad_email} bad email${data.bad_email === 1 ? '' : 's'}`}</span>
      </div>
      {nobody && <p className="adm-help__empty">No athletes are struggling to sign in right now.</p>}
      {/* Newest failure first; the server drops anyone whose last try is 30+ days old or who got in since. */}
      {data.athletes.length > 0 && (
        <ul className="adm-list">
          {data.athletes.map((a) => (
            <li key={a.user_id}>
              <Link className="adm-list__name" to={`/athletes/${a.user_id}`}>{a.name}</Link>
              <span className="adm-list__meta">
                {a.last_failed_at ? `Last tried ${when(a.last_failed_at)} · ` : ''}
                {a.reason === 'locked'
                  ? `Locked until ${when(a.locked_until) || 'soon'}`
                  : `${a.failed_count} failed attempt${a.failed_count === 1 ? '' : 's'}`}
                {a.last_login_at ? ` · last login ${when(a.last_login_at)}` : ' · never logged in'}
              </span>
            </li>
          ))}
        </ul>
      )}
      {(data.bad_email_athletes || []).length > 0 && (
        <div data-testid="login_issues_bad_email">
          <h3 className="adm-help__sub">Email needs fixing</h3>
          <ul className="adm-list">
            {data.bad_email_athletes.map((a) => (
              <li key={a.user_id}><Link className="adm-list__name" to={`/athletes/${a.user_id}`}>{a.name}</Link></li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
